import React from 'react';
import * as Styles from './BannerCloudflare.styles';
import { Button } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';
import { useHistory } from 'react-router';
import useLocale from '@/hooks/useLocale';
import { cloudflareAnalytics } from '@/analytics/cloudflare';

const { default: RocketSvg } = require('./rocketSvg');

const BannerCloudflare = ({
  title = 'Deixe seu site mais rápido e seguro com a CDN da Cloudflare',
  description = 'Acelere o tempo de carregamento do seu site, proporcionando uma experiência mais rápida e satisfatória para os seus visitantes grátis.',
  buttonCta = 'Ir para desempenho de sites',
  cloudflareList,
}) => {
  const history = useHistory();
  const { routes: routesLocale } = useLocale();
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 600;

  const handleRedirect = () => {
    cloudflareAnalytics.bottomBannerCta();
    history.push(`${routesLocale.products}${routesLocale.cloudflare}/${cloudflareList[0].hosting_id}`);
  };

  return (
    <Styles.CardWrapper>
      <Styles.Title data-testid="tilte">{title}</Styles.Title>

      <Styles.Description data-testid="description">
        {description}
      </Styles.Description>

      <Styles.ButtonWrapper>
        <Button
          testId="cta"
          label={buttonCta}
          variant="primary"
          size={mobile ? 'medium' : 'large'}
          onClick={handleRedirect}
        />
      </Styles.ButtonWrapper>

      <Styles.SvgWrapper>
        <RocketSvg mobile={mobile} />
      </Styles.SvgWrapper>
    </Styles.CardWrapper>
  );
};

export default BannerCloudflare;
